import { Suspense } from 'react';
import { useInView } from 'react-intersection-observer';

const LazyComponent = ({ Component }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px', threshold: 0.1 });

  const LoadComponent = inView;

  return (
    <div ref={ref} style={{ minHeight: LoadComponent ? 0 : '200px', opacity: LoadComponent ? 1 : 0 }}>
      {LoadComponent && (
        <Suspense fallback={<div style={{ height: '200px', width: '100%' }}></div>}>
          <Component />
        </Suspense>
      )}
    </div>
  );
};

export default LazyComponent;
